import React from 'react';
import PropTypes from 'prop-types';
import {getText} from 'helpers/text-helper';
import Button from 'components/ui/button/button';
import './loading.scss';

const Loading = ({languageId, loadErrMsg, handleLogout}) => {

	return (
		<div className="Loading">
			<div className="Loading-panel" >
				<div className="Loading-logoutBtn" > 
					<Button
						text={getText('general_logout', languageId)}
						classes={['pink']}
						onClick={() => {handleLogout();}}
					/>
				</div>
				<div className="Loading-content">
					<div className="Loading-circles">
						<div className="Loading-circle" />
						<div className="Loading-circle" />
						<div className="Loading-circle" />
					</div>
					<div className="Loading-text">{loadErrMsg}</div>
				</div>
			</div>
		</div>
	);
};

Loading.propTypes = {
	languageId: PropTypes.string.isRequired,
	loadErrMsg: PropTypes.string,
	handleLogout: PropTypes.func.isRequired
};

export default Loading;
